/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Faq_Issues_AInputs */

const en_mk_tb_faq_issues_a = /** @type {(inputs: Mk_Tb_Faq_Issues_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitLab.com supports read-only import and refresh with a read_api token. Preview changes and resolve conflicts before applying them. Closing a GitLab issue does not accept or release a Bystep task. Linear and Jira integrations are not available in this release.`)
};

const id_mk_tb_faq_issues_a = /** @type {(inputs: Mk_Tb_Faq_Issues_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitLab.com mendukung impor dan pembaruan dengan token read_api yang hanya memberi akses baca. Pratinjau perubahan dan selesaikan konflik sebelum menerapkannya. Menutup issue GitLab tidak menerima atau merilis tugas Bystep. Integrasi Linear dan Jira belum tersedia pada rilis ini.`)
};

/**
* | output |
* | --- |
* | "GitLab.com supports read-only import and refresh with a read_api token. Preview changes and resolve conflicts before applying them. Closing a GitLab issue do..." |
*
* @param {Mk_Tb_Faq_Issues_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_faq_issues_a = /** @type {((inputs?: Mk_Tb_Faq_Issues_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Faq_Issues_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_faq_issues_a(inputs)
	return en_mk_tb_faq_issues_a(inputs)
});